<template>
  <div class="verify-email-page">
    <div class="verify-container">
      <div class="logo-box">
        <img src="@/assets/logo.png" alt="ZENTRY" class="logo" />
      </div>

      <!-- Estado: Verificando -->
      <div v-if="loading" class="state-container">
        <div class="spinner-large"></div>
        <h2>Verificando tu correo...</h2>
        <p>Por favor espera un momento</p>
      </div>

      <!-- Estado: Éxito -->
      <div v-else-if="verified" class="state-container success-state">
        <div class="icon-circle success">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <h2>¡Email Verificado!</h2>
        <p class="message">{{ message }}</p>
        
        <div class="info-box">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M12 16V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <circle cx="12" cy="8" r="1" fill="currentColor"/>
          </svg>
          <div>
            <h3>¿Qué sigue?</h3>
            <p>Tu cuenta está pendiente de aprobación. El administrador del sistema revisará tu solicitud y te notificará por correo cuando esté lista.</p>
          </div>
        </div>

        <router-link to="/login" class="btn-primary">
          Ir a Iniciar Sesión
        </router-link>
      </div>

      <!-- Estado: Error -->
      <div v-else class="state-container error-state">
        <div class="icon-circle error">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <path d="M15 9L9 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M9 9L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </div>
        <h2>Error de Verificación</h2>
        <p class="message">{{ errorMessage }}</p>

        <div class="actions">
          <router-link to="/register" class="btn-secondary">
            Registrarse de nuevo
          </router-link>
          <router-link to="/login" class="btn-text">
            Ir a Iniciar Sesión
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authService } from '@/services/api'

export default {
  name: 'VerifyEmail',
  data() {
    return {
      loading: true,
      verified: false,
      message: '',
      errorMessage: ''
    }
  },
  async mounted() {
    const token = this.$route.query.token
    
    if (!token) {
      this.loading = false
      this.errorMessage = 'Token de verificación no proporcionado'
      return
    }

    try {
      const response = await authService.verifyEmail(token)
      
      if (response.success) {
        this.verified = true
        this.message = response.message || 'Tu correo ha sido verificado exitosamente.'
      } else {
        this.errorMessage = response.message || 'El token de verificación es inválido o ha expirado.'
      }
    } catch (error) {
      console.error('Error verifying email:', error)
      this.errorMessage = 'Error al verificar el correo. Por favor intenta de nuevo.'
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.verify-email-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.verify-container {
  background: white;
  border-radius: 20px;
  padding: 48px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.logo-box {
  margin-bottom: 32px;
}

.logo {
  max-width: 180px;
  height: auto;
}

.state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.state-container h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.state-container p.message {
  color: #64748b;
  font-size: 1rem;
  margin: 0;
}

.spinner-large {
  width: 64px;
  height: 64px;
  border: 4px solid #e2e8f0;
  border-top-color: #06b6d4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.icon-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle.success {
  background: #d1fae5;
  color: #10b981;
}

.icon-circle.error {
  background: #fee2e2;
  color: #ef4444;
}

.info-box {
  display: flex;
  gap: 16px;
  background: #f0f9ff;
  border-radius: 12px;
  padding: 20px;
  text-align: left;
  margin: 16px 0;
  color: #0284c7;
}

.info-box svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.info-box h3 {
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: #0369a1;
}

.info-box p {
  font-size: 0.9rem;
  margin: 0;
  color: #0284c7;
  line-height: 1.5;
}

.btn-primary {
  display: inline-block;
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 8px;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(6, 182, 212, 0.4);
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}

.btn-secondary {
  display: inline-block;
  width: 100%;
  padding: 14px 24px;
  background: #f1f5f9;
  color: #0f172a;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: #e2e8f0;
}

.btn-text {
  color: #64748b;
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.2s;
}

.btn-text:hover {
  color: #06b6d4;
}

@media (max-width: 480px) {
  .verify-container {
    padding: 32px 24px;
  }
  
  .logo {
    max-width: 150px;
  }
}
</style>
